export default "__VITE_ASSET__ea55c542__"